import $ from 'jquery';

export default () => {

    const $topTen = $('.sector-winner-name');
    const $micTenBlock = $('.sector-winner-container');
    const $arrow = $('.arrow');
    const $letterName = $('.letter-name');

    let urlBase = window.location.pathname;
    if ($('#sector-to-show-id').val().length) {
        urlBase = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'));
    }

    $topTen.click(function (e) {

        // Update the url after clicking in a sector
        let currentClass = $(this).find($arrow).attr('class');
        if (currentClass === 'arrow') {
            history.pushState(null, null, urlBase + '/' + $(this).find($letterName).attr('id'));
        } else {
            history.pushState(null, null, urlBase);
        }

        $(this).find($arrow).toggleClass('arrow arrow-down');
        $(this).find($micTenBlock).slideToggle(300);

    });


};
